"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareTomCorpus = prepareTomCorpus;
exports.prepareStoryGroups = prepareStoryGroups;
const taskStore_1 = require("../../../taskStore");
function prepareTomCorpus(blockList) {
    if (!((0, taskStore_1.taskStore)().version === 2)) {
        return null;
    }
    const taskIntro = blockList.flat().find((trial) => trial.itemId === 'ToM-intro');
    const blockTransition = blockList.flat().find((trial) => trial.itemId === 'ToM-transition');
    blockList.forEach((block, index) => {
        blockList[index] = block.filter((trial) => trial.itemId !== 'ToM-intro' && trial.itemId !== 'ToM-transition');
    });
    const sequentialTrials = [];
    const newCorpus = [];
    blockList.forEach((block) => {
        const firstTrial = block[0];
        const remainingTrials = block.slice(1);
        newCorpus.push(firstTrial);
        sequentialTrials.push(...remainingTrials);
    });
    (0, taskStore_1.taskStore)('sequentialTrials', sequentialTrials);
    (0, taskStore_1.taskStore)('corpora', { stimulus: newCorpus });
    return {
        taskIntro: taskIntro,
        blockTransition: blockTransition,
    };
}
function prepareStoryGroups(corpus) {
    if (!((0, taskStore_1.taskStore)().version === 2)) {
        return;
    }
    const storyGroups = [];
    for (let i = 0; i < (0, taskStore_1.taskStore)().numberOfStories; i++) {
        storyGroups.push([]);
    }
    corpus.forEach((trial) => {
        if (trial.storyGroup !== undefined) {
            storyGroups[trial.storyGroup].push(trial);
        }
        else {
            storyGroups[0].push(trial);
        }
    });
    return storyGroups;
}
